export const accessoriesPrefix = '/zubehoer';

export const urls = {
    // the `Infobar` will navigate through each of these steps
    // so the order is important
    steps: {
        room: {
            pattern: '/raum/:floorFamilyId?/:floorDecorArticleNumber?',
            builder: floorFamilyAndDecorBuilder('/raum'),
        },
        floor: {
            // do not forget to update `DistributionPackages/GesagtGetan.Theme/Classes/Eel/Helper/ShoppingPlannerHelper.php`
            pattern: '/boden/:floorFamilyId?/:floorDecorArticleNumber?',
            builder: floorFamilyAndDecorBuilder('/boden'),
        },
        accessoriesInsulation: {
            pattern: '/zubehoer/daemmung',
            builder: () => '/zubehoer/daemmung',
        },
        accessoriesSkirting: {
            pattern: '/zubehoer/leisten',
            builder: () => '/zubehoer/leisten',
        },
        accessoriesInstallation: {
            pattern: accessoriesPrefix + '/verlegung',
            builder: () => accessoriesPrefix + '/verlegung',
        },
        shoppingList: {
            pattern: '/einkaufszettel/:slugFromUrl?',
            builder: (slugFromUrl?: string | null) => `/einkaufszettel/${slugFromUrl ?? ''}`,
        },
    },
    sharing: {
        pattern: '/teilen/:slugFromUrl',
        builder: (slugFromUrl: string) => '/teilen/' + slugFromUrl,
    },
} as const;

function floorFamilyAndDecorBuilder(prefix: string) {
    return (floorFamilyId?: string, floorDecorArticleNumber?: string) => {
        if (floorFamilyId && floorDecorArticleNumber) {
            return prefix + '/' + floorFamilyId + '/' + floorDecorArticleNumber;
        }

        if (floorFamilyId && !floorDecorArticleNumber) {
            return prefix + '/' + floorFamilyId;
        }

        if (!floorFamilyId && floorDecorArticleNumber) {
            return prefix + '/null/' + floorDecorArticleNumber;
        }

        return prefix;
    };
}
